import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {isLoginCheck} from '../Middleware/Auth';

const PrivateRoute = ({component: Component, ...rest}) => {
    console.log(isLoginCheck());
    return (

        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => (
            isLoginCheck() ?
                <Component {...props} />
            : <Redirect to="/login" />
        )} />
    );
};

export default PrivateRoute;


// WEBPACK FOOTER //
// ./src/Route/PrivateRoute.js